// extracted by mini-css-extract-plugin
export default {"header":"MetaDataCard_header__zQ5yg","title":"MetaDataCard_title__N0xEu","text":"MetaDataCard_text__eJmL2","body":"MetaDataCard_body__5VEmm","grey":"MetaDataCard_grey__mqkVL"};